<div class="widget-library-page custom-page">
    <app-data-table addButtonText="{{ 'WidgetLibraryPage.AddButton' | translate }}" title="{{ 'WidgetLibraryPage.Title' | translate }}" filterPlaceholder="{{ 'WidgetLibraryPage.FilterPlaceholder' | translate }}" (openModal)="openWidgetLibrary($event)"
        (deleteRow)="deleteWidgetLibrary($event)" [displayedColumnsName]="displayedColumnsName"
        [displayedColumns]="displayedColumns" [data]="widgetLibraries">
    </app-data-table>
</div>